// Import necessary modules and functions from external libraries and our own project
import { Libraries } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import * as authSelectors from '../../../../redux/reducers/auth';
import { useGoogleMapsScript } from './useGoogleMapsScript'; // Import the custom hook

// Define a list of libraries to load from the Google Maps API
const libraries: Libraries = ['places', 'drawing', 'geometry'];

// Define a function component called MapProvider that takes a children prop
export function MapProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const user = useSelector(authSelectors.getAuthUser);
  if (!user || !user?.googleMapsApiKey) return <>{children}</>;

  const { scriptLoaded, loadError } = useGoogleMapsScript(user.googleMapsApiKey, libraries);

  if (loadError) return <p>Encountered error while loading google maps</p>;

  if (!scriptLoaded) return <p>Map Script is loading ...</p>;

  // Return the children prop wrapped by this MapProvider component
  return <>{children}</>;
}
